import { gql } from '@apollo/client';

export const ChangeKnowledgeDataStatus = gql`
    mutation changeKnowledgeDataStatus($knowledgeDataId: ID!, $status: Boolean!) {
        changeKnowledgeDataStatus(knowledgeDataId: $knowledgeDataId, status: $status) {
            ... on SuccessType {
                message
            }

            ... on ErrorType {
                message
            }
        }
    }
`;
